import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { QueryClientProvider } from "@tanstack/react-query"
import "./index.css"
import { App } from "./App"
import { initTelemetry, trackError } from "@rawa/telemetry"
import { createQueryClient } from "./queryClient"

initTelemetry("feedback-app")

// Built once, here, rather than inside the element below: a client constructed
// in the render tree is rebuilt on every render of whatever holds it.
const queryClient = createQueryClient()

window.addEventListener("unhandledrejection", (event) => {
  trackError(event.reason, { source: "unhandledrejection" })
})

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
)
